import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to add `rulesById` to the model data
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v12 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v12Projects(prevState.projects);
  }

  return nextState;
};

const v12Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            rulesById: {},
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
